import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class SubscriptionPlans extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "SubscriptionPlans";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,
      description: null,
      status: "DRAFT",
      interval: null,
      cycles: null,
      type: null,
      renew: false,
      prepaid: true,
      // billing: {
      //   interval: null,
      //   calendar: [],
      //   cycles: 1,
      //   type: null,
      //   prepaid: true,
      //   renew: false,
      //   total_amount: 0,
      //   total_items: 0,
      //   total_costs: 0,
      //   total_taxes: 0,
      //   total_discounts: 0,
      //   total_fees: 0,
      //   taxes_rate: 0,
      //   discounts_rate: 0,
      //   fees_rate: 0,
      //   costs_rate: 0,
      // },
      trial: {
        amount: null,
        days: null,
        enabled: false,
      },
      actions: {
        send_declined_notice: true,
        send_receipt: true,
        enable_autopay: true,
        send_token_authorization: true,
        send_reminder_days: 2,
        auth_required: true,
      },
      items: [],
      costs: [],
      taxes: [],
      discounts: [],
      fees: [],
      attributes: [],
      total_items: 0, //temp
      total_taxes: 0, //temp
      total_fees: 0, //temp
      total_costs: 0, //temp
      total_discounts: 0, //temp
      total_amount: 0, //temp
      total_revenue: 0, //temp
      interval_items: 0, //temp
      interval_taxes: 0, //temp
      interval_fees: 0, //temp
      interval_costs: 0, //temp
      interval_discounts: 0, //temp
      interval_amount: 0, //temp
      interval_revenue: 0, //temp
      tax: {}, //temp
      discount: {}, //temp
      fee: {}, //temp
      cost: {}, //temp
      product: {}, //temp
      meta_data: {},
      custom_fields: [],
      tags: [],
      notes: [],
      mid_id: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    if (data.mid) {
      data.mid = new models.api.Mids(data.mid);
    }

    if (data.subscriptions && data.subscriptions.length > 0) {
      data.subscriptions.map(async (subscriptions) => {
        subscriptions = new models.api.Subscriptions(subscriptions);
      });
    }

    return data;
  }
}
